import safeToBn from '@blockcatio/tabby-library/lib/utilities/safeToBn';

const calculateCost = (gasLimit, gasPrice) => {
  const limit = safeToBn(gasLimit.toString());
  const price = safeToBn(gasPrice.toString());
  return limit.mul(price);
};

/**
 * Attempts to find an affordable amount of gas to spend
 *
 * @param {Number} gasLimit - application-specified maximum
 * @param {String} recommendedPrice - gas price that is recommended in wei
 * @param {String} safeMinPrice - gas price based on last safe min in wei
 * @param {String|BN} balance - user's balance in wei
 * @return {String} - gasPrice to use, within user's balance in wei
 */
export default (gasLimit, recommendedPrice, safeMinPrice, balance) => {
  const balanceBn = safeToBn(balance);
  const safeMinCalculated = calculateCost(gasLimit, safeMinPrice);
  const recommendedCalculated = calculateCost(gasLimit, recommendedPrice);

  if (balanceBn.lt(safeMinCalculated)) {
    throw new Error('Could not find suitable price');
  }

  if (balanceBn.gte(recommendedCalculated)) {
    return recommendedPrice;
  }

  return balanceBn.div(safeToBn(gasLimit)).toString();
};



// WEBPACK FOOTER //
// ./src/utilities/calculateAffordableGas.js